import axios from 'axios'

export const companiesCompetitorBrands = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
    },
    readCompetitorBrandsSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    readCompetitorBrandsFailure(state) {
      state.loading = false
    },
    deleteCompetitorBrandSuccess(state, competitorBrandId) {
      state.data = state.data.filter((value) => value.id != competitorBrandId)
      state.loading = false
    },
    deleteCompetitorBrandFailure(state) {
      state.loading = false
    },
  },
  actions: {
    readCompetitorBrands({ commit }, company_uuid) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + company_uuid + '/competitor_brands.json')
        .then(res => {
          commit('readCompetitorBrandsSuccess', res.data)
        })
        .catch(err => {
          commit('readCompetitorBrandsFailure', err)
          console.error(err)
        })
    },
    deleteCompetitorBrand({ commit }, { company_uuid, competitor_brand_id }) {
      commit('apiConnect')
      axios
        .delete('/api/companies/' + company_uuid + '/competitor_brands/' + competitor_brand_id + '.json')
        .then(() => {
          commit('deleteCompetitorBrandSuccess', competitor_brand_id)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          commit('deleteCompetitorBrandFailure')
          console.error(err)
        })
    },
  }
}
